import { Component, OnInit } from '@angular/core';
import { TelecomService } from '../../../services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { forEachChild } from 'typescript';

@Component({
  selector: 'app-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.css']
})
export class BlacklistComponent implements OnInit {

  newRow: boolean = false;
  data: Array<any> = [];
  lobs:Array<any> = [];
  bluePrint = {'count': 0, 'dateAdded': this.formatDate(), 'phoneNumber': '+1'};
  formValid: boolean = true;
  lambdaError: boolean = false;
  lambdaMessage: string = '';

  constructor(private telecomService: TelecomService) { }

  ngOnInit() {
    this.getData();
    this.getLOBs();
    this.lambdaError = false;
    this.lambdaMessage = '';
  }

  getLOBs(){
    this.lobs = [];
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      resultData.lobList.forEach(element => {
        this.lobs.push(element[0]);
      });
    });
  }

  getData(){
    this.telecomService.getRows(environment.blacklistLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        console.log(response)
        this.data = response.body.blacklist.Items;
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.Error.message;
        console.error(response);
      }
    });
  }


  updateMode(gridAction: string){
    if(gridAction == 'add'){
      this.newRow = true;
    }else if(gridAction == 'edit'){
      this.newRow = false;
    }
  }

  handleButtonClick(event: any){
    console.log(event);
    this.newRow = false;
    if(event.button == "confirm" || event.button == "delete"){
      this.updateItem(event);
    }else if( event.button == "create"){
      this.newRow = true;
    }
  }

  updateItem(event: any){
    console.log("Update Item", event);
    let payload;
    if(event.button != "confirm"){
      let itemToSave = event.item;
      this.lambdaError = false;
      this.lambdaMessage = 'Saving Changes...'
      payload = {
        action: "delete",
        item: itemToSave
      }
    }
    else{
      let itemToSave = event.item;
      this.lambdaError = false;
      this.lambdaMessage = 'Saving Changes...'
      payload = {
        action: "put",
        item: itemToSave
      }
    }
    this.telecomService.saveRow(payload, environment.blacklistLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Data saved successfully.";
      }else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log(data.Error);
      }
    });
  }


  formatDate(){
    var today:any = new Date();
    var dd:any = today.getDate();
    var mm:any = today.getMonth() + 1;
    var yyyy:any = today.getFullYear();
    if(dd < 10){
      dd = '0' + dd;
    }
    if(mm < 10){
      mm = '0' + mm;
    }
    return mm + '/' + dd + '/' + yyyy;
  }


  cleanAndValidate(item: any){
    //remove empty comment
    if(item.comments == ""){
      delete item.comments;
      console.log('removed comment');
    }

    //validate
    if(!item.LOB){
      this.lambdaMessage = 'LOB not selected'
      this.lambdaError = true;
      return false;
    }

    return this.validatePhone(item);
    
  }


  validatePhone(item: any){
    this.lambdaMessage = '';
    this.lambdaError = false;
    if(!(item.phoneNumber[0] == '+' && item.phoneNumber[1] == 1)){
      this.lambdaError = true;
      this.lambdaMessage = "Missing '+1' at the beginning of phone number";
      return false;
    }

    //scrub input
    var test = item.phoneNumber
    console.log(test);
    if(test.startsWith('+')){
      test = test.slice(1, test.length);
    }
    test = test.split("-").join("");
    test = test.split("(").join("");
    test = test.split(")").join("");

    //is digital
    var reg = new RegExp('^[0-9]*$');
    if(!reg.test(test)){
      this.lambdaError = true;
      this.lambdaMessage = 'Invalid phone number'
      return false;
    }
    
    //proper length and extension, add +
    if(test.length < 11){
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too short'
      return false;
    }
    
    if(test.length > 11){
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too long'
      return false;
    }

    return true
  }

}

